// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rdx-arrow__container[data-v-b969b28c]{cursor:pointer;width:.8125rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
